import React from "react";
import heroBg from "../../assets/images/getInTouch.png";
import logo from "../../assets/images/logo.png";
import people from "../../assets/images/people.png";
import { MdPhoneInTalk } from "react-icons/md";
import { RiInstagramFill } from "react-icons/ri";
import { MdOutlineAccessTime } from "react-icons/md";
import { MdOutlineLocationOn } from "react-icons/md";
import { GoMail } from "react-icons/go";
import { FaLinkedin } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa6";
import PrimaryButton from "../common/PrimaryButton";
import { Link, useNavigate } from "react-router-dom";

type Navigations = {
  name: string;
  path: string;
};

const navigations: Navigations[] = [
  {
    name: "Advisory",
    path: "/advisory",
  },
  {
    name: "Consulting",
    path: "/consulting",
  },
  {
    name: "Coaching",
    path: "/advises",
  },
  {
    name: "Mentoring",
    path: "/mentoring",
  },
  {
    name: "Support Call",
    path: "/support-call",
  },
];

type Props = {
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const HeroSection = ({ setIsOpen }: Props) => {
  const navigate = useNavigate();

  return (
    <div className="relative jost-regular flex justify-center items-center max-w-screen-2xl mx-auto">
      <div className="relative w-full">
        <img
          src={heroBg}
          className="w-full object-cover min-h-[500px] object-center"
          alt=""
        />
        <div className="hidden absolute sm:flex flex-wrap justify-between px-6 text-white items-center top-0 w-full bg-black bg-opacity-60">
          <div className="flex flex-wrap">
            <div className="flex justify-center group cursor-pointer items-center py-4">
              <GoMail className="text-3xl group-hover:-translate-y-1 transition-all duration-300 text-white mx-4" />
              <a href="mailto:laila.khan@psycheethos.com">
                laila.khan@psycheethos.com
              </a>
            </div>
            <div className="w-[1px] h-16 bg-white bg-opacity-20 ml-4"></div>
            <div className="flex justify-center group cursor-pointer items-center py-4">
              <MdPhoneInTalk className="text-3xl group-hover:-translate-y-1 transition-all duration-300 text-white mx-4" />
              <p onClick={() => window.open("tel:+44485543091")}>
                +44485543091
              </p>
            </div>
            <div className="w-[1px] h-16 bg-white bg-opacity-20 ml-4"></div>
            <div className="flex justify-center group cursor-pointer items-center py-4">
              <MdOutlineLocationOn className="text-3xl group-hover:-translate-y-1 transition-all duration-300 text-white mx-4" />
              <p>71-75 Shelton Street Covent Garden, London WC2 9JQ U.K.</p>
            </div>
          </div>
          <div className="flex flex-wrap">
            <div className="flex justify-center group items-center py-3">
              <MdOutlineAccessTime className="text-3xl group-hover:-translate-y-1 transition-all duration-300 text-white mx-4" />
              <p>Mon-Fri:10am-4pm</p>
            </div>
            <div className="w-[1px] h-16 bg-white bg-opacity-20 ml-4"></div>
            <div className="flex justify-center gap-4 items-center py-3 mx-8">
              <div
                onClick={() =>
                  window.open(
                    "https://www.instagram.com/nightstarstorytelling/",
                  )
                }
                className="p-1 cursor-pointer border rounded-full w-10 h-10 hover:-translate-y-1 transition-all duration-300 flex justify-center items-center"
              >
                <RiInstagramFill className="text-2xl text-white" />
              </div>
              <div className="p-1 cursor-pointer border rounded-full w-10 h-10 hover:-translate-y-1 transition-all duration-300 flex justify-center items-center">
                <FaLinkedin className="text-2xl text-white" />
              </div>
              <div className="p-1 cursor-pointer border rounded-full w-10 h-10 hover:-translate-y-1 transition-all duration-300 flex justify-center items-center">
                <FaFacebook className="text-2xl text-white" />
              </div>
            </div>
          </div>
        </div>

        <div className="hidden sm:flex absolute justify-between px-20 text-white items-center md:top-32 xl:top-20 w-full">
          <div className="w-full pl-16">
            <img
              onClick={() => navigate("/")}
              src={logo}
              className="h-20"
              alt=""
            />
          </div>
          <div className="hidden sm:block">
            <PrimaryButton
              onClick={() => setIsOpen(true)}
              className="w-[300px] uppercase"
              icon
            >
              Book a Consultation
            </PrimaryButton>
          </div>
        </div>
      </div>

      <div className="absolute flex flex-wrap justify-between text-white items-center md:bottom-[20%] xl:bottom-[30%] w-full">
        <div className="w-full flex justify-between items-center py-5">
          <div className="flex flex-col flex-wrap gap-5 px-4 sm:pl-32 max-w-[600px]">
            <h1 className="text-2xl sm:text-6xl">
              Get In
              <span className="text-2xl sm:text-6xl italic font-eiko-thin">
                Touch
              </span>
            </h1>
            <p>
              Have any questions? Reach out to us from our contact form <br />
              and we will get back to you shortly.
            </p>
          </div>
        </div>
      </div>
      <div className="absolute flex flex-wrap justify-between text-white items-center bottom-0 w-full">
        <div className="w-full h-[1px] bg-white bg-opacity-20"></div>
        <div className="w-full flex justify-between items-center py-5">
          <div className="flex flex-wrap gap-5 px-4 sm:pl-32">
            {navigations.map((navigation, index) => (
              <Link
                to={navigation.path}
                key={index}
                className="hover:underline"
              >
                <p>{navigation.name}</p>
              </Link>
            ))}
          </div>
          <div className="hidden sm:flex flex-wrap gap-2 sm:gap-5 mr-20">
            <img src={people} className="" alt="" />
            <p className="max-w-[200px]">
              2000+ people have been consulted and helped
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
